
    import { Vue,Component } from 'vue-property-decorator'
    import { Random } from 'mockjs';
    import UploadCropper from 'vue-upload-cropper'
    import { State,Action,namespace } from 'vuex-class'
    import FormBuilder from '../../components/common/form-builder.vue'
    import Partner from '../../components/partner.vue'
    import { regionData,CodeToText } from 'element-china-area-data'
    import {province} from '../../assets/province'
    import { pca, pcaa } from 'area-data';
    const mail = namespace('mail')
    const inbound = namespace('inbound')
    const site = namespace('site')
    const common = namespace('common')

    @Component({
        components: {
            FormBuilder,
            Partner,
	        UploadCropper,
        }
    })
    export default class Home extends Vue{
        pcaa = pcaa
        province = province
        options:any = regionData
	    showReg: Boolean = false
	    regText: String = ""
        props:any = {
          value: 'label'
        }
        editStatus:boolean = false //是否为编辑状态
        id:string = ''
        // partnerIcon:string = '' //快递图标
        expressForm:any = {
            code: '',
            partner: '',
            ordertype: 'eorder',
            money: '12',
            cost: '5',
            desc: '',
            paytype: 'weixin',
            GoodsName: '生活用品',
            GoodsWeight: 1,
            id: '',
            SenderName: '',
            Senderarea: [],
            SenderAddress: '',
            SenderMobile: '',
            ReceiverName: '',
            Receiverarea: [],
            ReceiverAddress: '',
            ReceiverMobile: ''
        }
        get rules(){
            if (this.expressForm.ordertype == 'eorder') {
                return {
                    GoodsName: [{ required: true, message: '物品类型不能为空'}],
                    code: [{ required: false}],
                    partner: [{ required: true, message: '快递单位不能为空'}],
                    GoodsWeight: [{required: true}],
                    SenderName: [{required: true, message: '寄件人真实姓名不能为空'}],
                    Senderarea: [{required: true, message: '寄件人省市区不能为空'}],
                    SenderAddress: [{required: true, message: '寄件人详细地址不能为空'}],
                    SenderMobile: [{required: true, message: '寄件人手机号不能为空'}],
                    ReceiverName: [{required: true, message: '收件人真实姓名不能为空'}],
                    Receiverarea: [{required: true, message: '收件人省市区不能为空'}],
                    ReceiverAddress: [{required: true, message: '收件人详细地址不能为空'}],
                    ReceiverMobile: [{required: true, message: '收件人手机号不能为空'}],
                    money: [{required: true, message: '寄件费用不能为空'}],
                    cost: [{required: true, message: '寄件成本不能为空'}],
                }
            } else {
                return {
                    code: [{ required: true, message: '快递单号不能为空'}],
                    GoodsName: [{ required: false}],
                    partner: [{ required: true, message: '快递单位不能为空'}],
                    GoodsWeight: [{required: true}],
                    SenderName: [{required: true, message: '寄件人真实姓名不能为空'}],
                    Senderarea: [{required: false}],
                    SenderAddress: [{required: false}],
                    SenderMobile: [{required: true, message: '寄件人手机不能为空'}],
                    ReceiverName: [{required: false}],
                    Receiverarea: [{required: true, message: '收件人省市区不能为空'}],
                    ReceiverAddress: [{required: false}],
                    ReceiverMobile: [{required: false}],
                    money: [{required: true, message: '寄件费用不能为空'}],
                    cost: [{required: true, message: '寄件成本不能为空'}],
                }
            }
        }
        @mail.Action('addMail') addMail:any
        @mail.Action('editMail') editMail:any
        @mail.Action('getMailDetail') getMailDetail:any
	    @common.Action('addressResolve') addressResolve: any
        @inbound.Action('getPhoneTips') getPhoneTips:any
	    @site.State('info') site:any
	    // 检查是否为编辑页面
        async created(){
            const id = this.$route.query.id;
            if(id){
                this.id = id
                this.editStatus = true
                this.getDetail(id)
            }
            console.log(province);
	        this.setSender();
        }
        // 获得详情信息
        async getDetail(id:string){
            const data = await this.getMailDetail(id)
            if(data){
                this.expressForm.code = data.code
                this.expressForm.partner = data.partner._id
                // this.partnerIcon = data.partner.pinyin
                this.expressForm.ordertype = data.ordertype
                this.expressForm.money = data.money
                this.expressForm.cost = data.cost
                this.expressForm.desc = data.desc
                this.expressForm.GoodsName = data.GoodsName
                this.expressForm.GoodsWeight = data.GoodsWeight
                this.expressForm.SenderName = data.SenderName
                this.expressForm.Senderarea = data.Senderarea
                this.expressForm.SenderAddress = data.SenderAddress
                this.expressForm.SenderMobile = data.SenderMobile
                this.expressForm.ReceiverName = data.ReceiverName
                this.expressForm.Receiverarea = data.Receiverarea
                this.expressForm.ReceiverAddress = data.ReceiverAddress
                this.expressForm.ReceiverMobile = data.ReceiverMobile
            }
        }
        // 生成id
        genId(){
            this.expressForm.id = Random.id();
        }
        // 检查表单必填项目是否已经填写完毕
        submitForm():any{
            return new Promise((resovle,reject)=>{
                this.$refs['expressForm'].validate((valid:any) => {
                        resovle(valid);
                });
            })
        }
        // 转换省市区
        handleAreaChange(e:any){
            console.log(e);
            
        }
        // 重置表单
        resetForm(){
            this.$refs['expressForm'].resetFields()
        }
	    async startReg(){
	        try{
				const {  city_name,county_name, mobile, name,  note, province_name,} = await this.addressResolve({
					text: this.regText,
				})
			    this.expressForm.ReceiverName = name;
				this.expressForm.ReceiverMobile = mobile;
				this.expressForm.ReceiverAddress = note;
				this.expressForm.Receiverarea = [province_name,city_name,county_name]
			    this.showReg = false;
	        }catch(err){
		        this.$message.error(err.message);
	        }
	    }
        // 立即添加
        async add(){
            const res = await this.submitForm()
            if(res){
                const data = await this.addMail(this.expressForm)
                if(data){
                    // this.$message({ message: '', type: 'success' });
                    this.$confirm('添加成功', '提示', {
                        confirmButtonText: '继 续',
                        cancelButtonText: '确 定',
                        type: 'success'
                    }).then(() => {
                        this.expressForm.code = ''
                    }).catch(() => {
                        this.resetForm()         
                    });
                    
                }
            }
        }
        // 立即编辑
        async edit(){
            const res = await this.submitForm()
            if(res){
                const data = await this.editMail({
                    id: this.id,
                    data: this.expressForm
                })
                if(data){
                    this.$message({ message: '编辑成功', type: 'success' });
                    this.resetForm()
                    this.$router.go(-1)
                }
            }
        }
	    setSender(){
	            const { area, eorderAddress, name, } = this.site;
	            this.expressForm.Senderarea = area;
	            this.expressForm.SenderAddress = eorderAddress;
	            this.expressForm.SenderName = name;
	    }
        // 搜索电话号码
        async searchPhoneAsync(queryString:any, cb:any) {
            if(!queryString){
                cb([])
            }
            if(this.expressForm.SenderMobile.length > 3 && this.expressForm.SenderMobile.length !== 11){
                const res = await this.getPhoneTips({
                    phone: this.expressForm.SenderMobile
                })
                cb(res)
            }else{
                cb([])
	        }
        }
        // 选择搜索出来的电话号码
        phoneSelect(e:any){
            this.expressForm.SenderMobile = e.phone
            this.expressForm.SenderName = e.name
        }
    }
